import { load3DLogo } from '../../vendor/index.js';

export default {
  init() {
      //init 3D logo
      let scene3D;
      const logoContainer = $('.logo_3d_confirmation .item-3d');

      load3DLogo({ container: logoContainer[0], dark: true }).then((scene) => {
        scene3D = scene;
        scene3D.play();
      });
  },
};
